import React from 'react';
import { FlexGrid, getClassNameFactory } from '@dcl/ui';
import './index.css';
import { ISupportHours } from './SupportHoursTypes';
import { SupportHoursHeader } from './components/SupportHoursHeader/SupportHoursHeader';
import { SupportHoursTabs } from './components/SupportHoursTabs/SupportHoursTabs';
import { SupportHoursTable } from './components/SupportHoursTable/SupportHoursTable';

export const SupportHours: React.FC<ISupportHours> = (props) => {
  const { heading, title, description, apiUrlHost, supportInfo = [] } = props;

  const getClassName = getClassNameFactory(SupportHours.displayName);

  const renderSupportContent = () => {
    if (!supportInfo || supportInfo.length === 0) {
      return null;
    }

    const supportHoursDataClass = getClassName({
      descendantName: 'supportHoursData',
    });

    if (supportInfo.length > 1) {
      return (
        <FlexGrid.Col xs={12} lg={12} md={12} className={supportHoursDataClass}>
          <SupportHoursTabs data={supportInfo} apiUrl={apiUrlHost} />
        </FlexGrid.Col>
      );
    }

    if (supportInfo.length === 1) {
      const transformedUrl = `${apiUrlHost}?productKey=${supportInfo[0].scheduleGroupID}`;
      return (
        <FlexGrid.Col xs={12} lg={12} md={12} className={supportHoursDataClass}>
          <SupportHoursTable
            apiUrl={transformedUrl}
            searchTitle="Search"
            normalHours={`${supportInfo[0].supportType} 08:00 am -09:00 pm ET`}
            phNumber={
              supportInfo[0].phoneNumberValue +
              supportInfo[0].phoneNumberExensionValue
            }
            normalHoursLabel={supportInfo[0].normalHoursLabel}
            phoneNumberLabel={supportInfo[0].phoneNumberLabel}
          />
        </FlexGrid.Col>
      );
    }

    return null;
  };

  return (
    <>
      <div className={getClassName()}>
        <SupportHoursHeader
          productTitle={heading}
          pageTitle={title}
          pageDescription={description}
        />
      </div>
      {renderSupportContent()}
    </>
  );
};

SupportHours.displayName = 'SupportHours';
